import axios from 'axios';
import * as yup from 'yup';
import { patientSchema, reportSchema } from '~/schemas';
const responseSchema = yup
    .object()
    .camelCase()
    .required()
    .shape({
    message: yup.string().required().oneOf(['OK']),
    data: yup
        .object()
        .camelCase()
        .required()
        .shape({
        patient: patientSchema,
        reports: yup.array().of(reportSchema).ensure(),
    }),
});
export async function fetchPatientData({ patientId }) {
    const url = `/api/patient/fetch/${patientId}`;
    const response = await axios.post(url);
    const { data: { patient, reports } } = await responseSchema.validate(response.data);
    return {
        // @ts-ignore
        patient,
        reports,
    };
}
